import { Link as GatsbyLink } from 'gatsby';
import { PropTypes } from 'prop-types';
import React from 'react';

import ExternalLink from './ExternalLink';

const Link = ({ children, className, style, to }) => {
  // trailing slash check
  let url = to;
  if (url[url.length - 1] !== '/') url += '/';

  return url.includes('https') || url.includes('.com') ? (
    <ExternalLink className={className} href={url} style={style}>
      {children}
    </ExternalLink>
  ) : (
    <GatsbyLink className={className} style={style} to={url}>
      {children}
    </GatsbyLink>
  );
};

Link.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
  style: PropTypes.object,
  to: PropTypes.string,
};

export default Link;
